/**
 * 连锁块管理
 */
 import axios from '../request';
 export default{
    

    /**
     * 连锁块管理
     */
    // 查询连锁块列表信息
    searchBlockList: params =>
        axios.post(`/materials/chainBlock/findList?pageNum=${params.pageNum}&pageSize=${params.pageSize}`, params),
    // 添加或修改连锁块信息
    insertBlockOrUpdate: params =>
        axios.post('/materials/chainBlock/save', params),
    // 连锁块查班组
    detailsBlockGroup: params =>
        axios.post('/materials/chainBlock/detailByChainBlockId', params),
    // 删除连锁块信息
    deleteBlockDevice: params =>
        axios.post('/materials/chainBlock/delete', params),
    //连锁块管理下拉
    getAllBlockDevice: params =>
        axios.get('/materials/chainBlock/', {params}),
    //导出数据
    exportBlockDatas:params=>
        axios({
            method: 'get',
            url: '/materials/',
            responseType: 'blob',
            params: params
        }),


 }